<template>
    <form @submit.prevent="submit">
        <modal>
            <modal-header>
                <translate>Angebot anfragen</translate>
            </modal-header>
            <modal-content>
                <p class="body-2">
                    <translate>Ihnen gefällt dieses Angebot besser, senden Sie uns eine Anfrage und wir erstellen Ihnen ein neues Angebot</translate>
                </p>
                <table class="table table--stripped table--td-top">
                    <thead>
                    <tr>
                        <th>
                            <translate>P.-Nr.</translate>
                        </th>
                        <th>
                            <translate>Stück</translate>
                        </th>
                        <th>
                            <translate>Lieferzeit <span>ab Bestellung</span></translate>
                        </th>
                        <th>
                            <translate>Lieferdatum<span>bei heutiger Bestellung</span></translate>
                        </th>
                        <th>
                            <translate>Stückpreis</translate>
                        </th>
                        <th>
                            <translate>Nettopreis</translate>
                        </th>
                        <th>
                            <translate>Steuer<span>19% Ust.</span></translate>
                        </th>
                        <th>
                            <translate>Gesamtpreis<span>inkl. Versand</span></translate>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{{ selectedAlternateOffer.prod_no }}</td>
                        <td v-html="selectedAlternateOffer.lot_qty"></td>
                        <td v-html="selectedAlternateOffer.lot_delivery"></td>
                        <td v-html="selectedAlternateOffer.lot_delivery_dates"></td>
                        <td v-html="selectedAlternateOffer.price_per_unit"></td>
                        <td v-html="selectedAlternateOffer.lot_offer"></td>
                        <td v-html="selectedAlternateOffer.lot_ust"></td>
                        <td v-html="selectedAlternateOffer.offer_price"></td>
                    </tr>
                    </tbody>
                </table>
            </modal-content>
            <modal-content>
                <form-text id="request_comment" :label="this.$gettext('Ihr Kommentar')" :error="form.errors.request_comment" v-model="form.request_comment" />
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}"><translate>Angebot anfragen</translate></form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import {useForm} from '@inertiajs/vue3';
import FormText from '@partfactory/Shared/Form/FormText';

export default {
    name: 'ComponentRequestAlternateOfferModal',
    components: {FormText, ModalContent, ModalHeader, FormButton, ModalActions, Modal},
    props: {
        askForQuote: Object,
        selectedAlternateOffer: Object
    },
    emit: ['closeDialog'],
    data() {
        const form = useForm({
            request_comment: null,
        });

        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('offer.request', {'askForQuote': this.askForQuote.id, 'bidRoundMember': this.selectedAlternateOffer.id}), {
                    onSuccess: () => this.$emit('closeDialog')
                });
        }
    }
};
</script>
